import { IonContent, IonPage } from '@ionic/react'
import { useContext, useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { VALIDATE_STATUS } from '../../../common'
import { CustomSpacer, FooterButtons, StyleIonHeader, TextStyle } from '../../../components'
import { StyleIonInput } from '../../../components/atoms/input/StyleIonInput'
import { StoresContext } from '../../../provider/StoreProvider'

export const QnaRegister: React.FC<RouteComponentProps> = ({ history }) => {
  const { myStore } = useContext(StoresContext)
  const [title, setTitle] = useState<string | undefined>()
  const [content, setContent] = useState<string | undefined>()
  const [validateStatus, setValidateStatus] = useState<VALIDATE_STATUS>(VALIDATE_STATUS.INPUT)

  const onInputTitle = (title: string | number) => {
    setTitle(String(title))
  }

  const onInputContent = (content: string | number) => {
    setContent(String(content))
  }

  const validate = () => {
    if (title != undefined && content != undefined) {
      if (title?.length > 0 && content?.length > 0) {
        setValidateStatus(VALIDATE_STATUS.OKAY)
      } else {
        setValidateStatus(VALIDATE_STATUS.INPUT)
      }
    }
  }

  useEffect(() => {
    validate()
  }, [title, content])

  const onRegisterQna = async () => {
    if (title != undefined && content != undefined) {
      await myStore.registerQna({ title: title, content: content })
      history.push('/myPage/qna')
      location.reload()
    }
  }

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'1:1 문의하기'} href={'/myPage/qna'} />
      <IonContent>
        <TitleContainer>
          <TextStyle type={'b_16'}>문의 제목</TextStyle>
          <CustomSpacer spacing="8px" />
          <StyleIonInput
            inputType={'INPUT'}
            inputStyle={'BOX'}
            type={'text'}
            inputmode={'text'}
            onInput={onInputTitle}
            placeholder={'제목을 입력해주세요. (최대 80자)'}
          />
        </TitleContainer>
        <ContentContainer>
          <TextStyle type={'b_16'}>문의 내용</TextStyle>
          <CustomSpacer spacing="8px" />
          <StyleIonInput
            inputType={'TEXTAREA'}
            inputStyle={'BOX'}
            type={'text'}
            inputmode={'text'}
            onInput={onInputContent}
            placeholder={'내용을 입력해주세요.'}
          />
        </ContentContainer>
      </IonContent>
      <FooterButtons
        button={{
          color: 'dark',
          text: validateStatus !== VALIDATE_STATUS.OKAY ? '내용을 입력해주세요.' : '문의하기',
          disabled: validateStatus !== VALIDATE_STATUS.OKAY ? true : false,
          onClick: () => onRegisterQna(),
        }}
      />
    </IonPage>
  )
}

const TitleContainer = styled.div`
  padding: 24px 20px;
`

const ContentContainer = styled.div`
  padding: 0 20px;
`
